export default {
    name:'Quill',
    props: {
        value: {
            type: String
        }
    },
    data() {
        return {     
            editorOption: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'code-block'],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'script': 'sub' }, { 'script': 'super' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'align': [] }],
                        ['link', 'image', 'video']
                    ],
                    //imageResize: {
                    //    displayStyles: {
                    //        backgroundColor: 'black',
                    //        border: 'none',
                    //        color: 'white'
                    //    },
                    //    modules: ['Resize', 'DisplaySize', 'Toolbar']
                    //}
                },
                theme:'snow'
            }
        };
    },
};